import React from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowRight, Trophy, ShieldCheck, Clock, CreditCard, BookOpen, Gift } from 'lucide-react';
const tomos = [{
  text: 'Tomo 1: Fundamentos & Herrero (50 pág.)',
  value: '$8.000'
}, {
  text: 'Tomo 2: Línea Módena (50 pág.)',
  value: '$8.000'
}, {
  text: 'Tomo 3: A30 New & DVH (50 pág.)',
  value: '$10.000'
}, {
  text: 'Tomo 4: Cortes & Fórmulas (50 pág.)',
  value: '$12.000'
}, {
  text: 'Tomo 5: Presupuestador Pro (50 pág.)',
  value: '$10.000'
}, {
  text: 'Tomo 6: Instalación & Service (50 pág.)',
  value: '$8.000'
}];
const bonos = [{
  text: 'Bono 1: Kit Lista Maestra',
  value: '$35.000'
}, {
  text: 'Bono 2: Scripts WhatsApp + IG',
  value: '$28.000'
}, {
  text: 'Bono 3: Checklist Medición',
  value: '$25.000'
}, {
  text: 'Bono 4: Pack Croquis',
  value: '$32.000'
}, {
  text: 'Bono 5: Guía Control Calidad',
  value: '$22.000'
}, {
  text: 'Bono 6: Tracker Costos',
  value: '$28.000'
}];
export function OfferSection() {
  return <section id="oferta" className="py-8 md:py-12 bg-white scroll-mt-12" data-id="element-66">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-67">
        <div className="text-center mb-6 md:mb-10" data-id="element-68">
          <h2 className="text-3xl md:text-5xl font-black text-matte mb-2" data-id="element-69">
            Todo esto es tuyo hoy
          </h2>
          <div className="w-16 h-1 bg-gold mx-auto" data-id="element-70"></div>
        </div>

        {/* Value Stack */}
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="max-w-2xl mx-auto mb-8 md:mb-12" data-id="element-71">
          {/* Tomos */}
          <div className="bg-steel/5 border-2 border-steel/20 p-4 md:p-6 mb-3" data-id="element-72">
            <h3 className="text-sm font-black text-steel uppercase tracking-wider mb-3 flex items-center" data-id="element-73">
              <BookOpen className="w-5 h-5 mr-2" data-id="element-74" /> 6 Tomos Técnicos
            </h3>
            <div className="space-y-1.5" data-id="element-75">
              {tomos.map((item, i) => <div key={i} className="flex items-center justify-between py-1.5 border-b border-steel/10 last:border-0" data-id="element-76">
                  <div className="flex items-center" data-id="element-77">
                    <BookOpen className="w-4 h-4 mr-2 text-steel" data-id="element-78" />
                    <span className="text-sm md:text-base font-bold text-matte" data-id="element-79">
                      {item.text}
                    </span>
                  </div>
                  <span className="text-sm font-bold text-steel ml-2 flex-shrink-0" data-id="element-80">
                    Valor {item.value}
                  </span>
                </div>)}
            </div>
          </div>

          {/* Bonos */}
          <div className="bg-gold/5 border-2 border-gold/30 p-4 md:p-6 mb-3" data-id="element-81">
            <h3 className="text-sm font-black text-gold uppercase tracking-wider mb-3 flex items-center" data-id="element-82">
              <Gift className="w-5 h-5 mr-2" data-id="element-83" /> 6 Bonos Exclusivos
            </h3>
            <div className="space-y-1.5" data-id="element-84">
              {bonos.map((item, i) => <div key={i} className="flex items-center justify-between py-1.5 border-b border-gold/10 last:border-0" data-id="element-85">
                  <div className="flex items-center" data-id="element-86">
                    <Gift className="w-4 h-4 mr-2 text-gold" data-id="element-87" />
                    <span className="text-sm md:text-base font-bold text-matte" data-id="element-88">
                      {item.text}
                    </span>
                  </div>
                  <div className="flex items-center ml-2 flex-shrink-0" data-id="element-89">
                    <span className="text-xs text-gray-400 line-through mr-2" data-id="element-90">
                      {item.value}
                    </span>
                    <span className="text-sm font-black text-green-600 uppercase" data-id="element-91">
                      Gratis
                    </span>
                  </div>
                </div>)}
            </div>
          </div>

          {/* Total */}
          <div className="text-center bg-matte text-white py-3 border-l-4 border-gold" data-id="element-92">
            <p className="text-lg font-medium" data-id="element-93">
              Valor total:{' '}
              <span className="line-through text-gray-400 mx-2" data-id="element-94">$226.000</span>
            </p>
          </div>
        </motion.div>

        {/* Pricing Cards */}
        <div id="precios" className="grid md:grid-cols-2 gap-4 md:gap-6 max-w-4xl mx-auto scroll-mt-16" data-id="element-95">
          {/* Opción 1 */}
          <motion.div initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4
        }} className="border-2 border-gray-200 bg-white flex flex-col shadow-md" data-id="element-96">
            <div className="p-4 md:p-6 bg-gray-50 border-b border-gray-200 text-center" data-id="element-97">
              <h4 className="text-xl md:text-2xl font-black text-matte mb-2" data-id="element-98">
                SUPER COMBO PRO
              </h4>
              <div className="flex items-center justify-center gap-2" data-id="element-99">
                <span className="text-base md:text-lg text-gray-400 line-through font-bold" data-id="element-100">
                  $34.000
                </span>
                <span className="text-3xl md:text-4xl font-black text-steel" data-id="element-101">
                  $19.990
                </span>
                <span className="text-sm font-bold text-gray-500" data-id="element-102">ARS</span>
              </div>
            </div>
            <div className="p-4 md:p-6 flex-grow flex flex-col" data-id="element-103">
              <p className="text-sm font-bold text-gray-600 mb-4 text-center" data-id="element-104">
                Incluye los 6 Tomos + 6 Bonos (480 pág.)
              </p>
              <a href="https://solucionstore.shop/cart/45494138568895:1" target="_blank" rel="noopener noreferrer" className="mt-auto block w-full bg-gold text-matte text-center font-black py-4 text-lg hover:bg-yellow-500 transition-colors uppercase shadow-md" data-id="element-105">
                Comprar Opción 1 →
              </a>
            </div>
          </motion.div>

          {/* Opción 2 */}
          <motion.div initial={{
          opacity: 0,
          x: 15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4
        }} className="border-4 border-gold bg-white flex flex-col relative shadow-xl md:-translate-y-2" data-id="element-106">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-gold text-matte font-black px-4 py-1 uppercase tracking-widest flex items-center shadow-md text-xs" data-id="element-107">
              <Trophy className="w-4 h-4 mr-1.5" data-id="element-108" /> Más Elegida
            </div>
            <div className="p-4 md:p-6 bg-matte text-center pt-8" data-id="element-109">
              <h4 className="text-xl md:text-2xl font-black text-white mb-2" data-id="element-110">
                COMBO COMPLETO + PACK PRO
              </h4>
              <div className="flex items-center justify-center gap-2" data-id="element-111">
                <span className="text-base md:text-lg text-gray-400 line-through font-bold" data-id="element-112">
                  $43.000
                </span>
                <span className="text-3xl md:text-4xl font-black text-gold" data-id="element-113">
                  $27.990
                </span>
                <span className="text-sm font-bold text-gray-400" data-id="element-114">ARS</span>
              </div>
            </div>
            <div className="p-4 md:p-6 flex-grow flex flex-col" data-id="element-115">
              <ul className="space-y-2 mb-4 md:mb-6 text-sm" data-id="element-116">
                <li className="flex items-center font-black text-matte pb-2 border-b border-gray-100" data-id="element-117">
                  <Check className="w-4 h-4 text-green-600 mr-2" data-id="element-118" /> Todo lo de
                  la Opción 1
                </li>
                <li className="flex items-start pt-2" data-id="element-119">
                  <ArrowRight className="w-4 h-4 text-gold mr-2 mt-0.5 flex-shrink-0" data-id="element-120" />
                  <span className="font-bold text-steel" data-id="element-121">
                    + Pack de Ingeniería (Master-Calc, Detalles Técnicos, Manual
                    Herrajes, Guía DVH, 530 páginas)
                  </span>
                </li>
              </ul>
              <a href="https://solucionstore.shop/cart/45494160785599:1" target="_blank" rel="noopener noreferrer" className="mt-auto block w-full bg-gold text-matte text-center font-black py-4 text-lg hover:bg-yellow-500 transition-colors uppercase shadow-[0_0_15px_rgba(212,160,23,0.4)]" data-id="element-122">
                Comprar Opción 2 →
              </a>
            </div>
          </motion.div>
        </div>

        <div className="flex flex-wrap justify-center gap-4 mt-6 md:mt-8 text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-123">
          <span className="flex items-center" data-id="element-124">
            <ShieldCheck className="w-4 h-4 mr-1" data-id="element-125" /> Pago seguro
          </span>
          <span className="flex items-center" data-id="element-126">
            <Clock className="w-4 h-4 mr-1" data-id="element-127" /> Acceso inmediato
          </span>
          <span className="flex items-center" data-id="element-128">
            <CreditCard className="w-4 h-4 mr-1" data-id="element-129" /> Mercado Pago
          </span>
        </div>
      </div>
    </section>;
}